<template>
    <div class="container raw-view">
        <div class="row">
            <div :class="'col-'+block.value[2]" v-html="block.value[0]"></div>
            <div :class="'col-'+(12-block.value[2])" v-html="block.value[1]"></div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.form-control {
    min-height: 2.5rem;
}

</style>

<style>
.raw-view p {
    min-height: 22px;
}
</style>

<script>
export default {
    data: () => ({
        editor: null
    }),
    props: ['block'],
    components: {

    },
    methods: {

    },
    mounted () {

    }
}
</script>
